export default __webpack_public_path__ + "static/media/martin_depend.f8811c7b.png";